import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { ClientError } from "graphql-request";

import { graphql } from "lib/generated/app-service-gql";
import {
  AdminSwitchTeamMutation,
  AdminSwitchTeamMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { APP_TOKEN_QUERY_KEY } from "../useAppToken";
import { useGraphQlMutation } from "../useGraphQlClient";
import { CURRENT_USER_QUERY_KEY } from "../users/useCurrentUser";

const adminSwitchTeamMutation = graphql(`
  mutation adminSwitchTeam($input: AdminSwitchTeamInput!) {
    adminSwitchTeam(input: $input) {
      userGuid
    }
  }
`);

/**
 * Staff only: moves a user, the caller included, into another team of their company. For the
 * caller moving themselves without staff rights, see `teams/useSwitchTeam`.
 */
export function useSwitchTeam(
  options?: UseMutationOptions<
    AdminSwitchTeamMutation,
    ClientError,
    AdminSwitchTeamMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  return useGraphQlMutation(adminSwitchTeamMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      // The app token carries the caller's team.
      void queryClient.invalidateQueries(APP_TOKEN_QUERY_KEY);
      void queryClient.invalidateQueries(CURRENT_USER_QUERY_KEY);
      void queryClient.invalidateQueries(["userDetails", variables.input.userGuid]);
      void queryClient.invalidateQueries(["teams", "currentTeamInfo"]);
      options?.onSuccess?.(data, variables, context);
    },
  });
}
